export const DroppableType = {
  FIELD: 'FIELD',
  SECTION: 'SECTION',
  FIELD_OPTION: 'FIELD_OPTION',
};
